// extracted by mini-css-extract-plugin
export default {"user-menu":"UserMenu_user-menu__Taf9i","user-gravatar":"UserMenu_user-gravatar__ejswV","unknown-user":"UserMenu_unknown-user__k2UE6","login-button":"UserMenu_login-button__eCiaa"};